module.exports = __webpack_public_path__ + "static/media/logo_utp.ced98694.png";